import type { LogoType } from '../../types';

export const logoSlider: LogoType[] = [
  {
    id: 'a4b8e1de',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo1.png',
        name: 'logo1.png',
        alt: '',
        width: 299,
        height: 267
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'd9388035',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo2.png',
        name: 'logo2.png',
        alt: '',
        width: 300,
        height: 261
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '3b5e360c',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo3.png',
        name: 'logo3.png',
        alt: '',
        width: 297,
        height: 300
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '565300ac',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo4.png',
        name: 'logo4.png',
        alt: '',
        width: 318,
        height: 299
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'b6ca10e9',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo5.png',
        name: 'logo5.png',
        alt: '',
        width: 228,
        height: 300
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '16c57339',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo6.png',
        name: 'logo6.png',
        alt: '',
        width: 300,
        height: 237
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'b1ecf9ca',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo7.png',
        name: 'logo7.png',
        alt: '',
        width: 301,
        height: 299
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'f83c3863',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo8.png',
        name: 'logo8.png',
        alt: '',
        width: 300,
        height: 300
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '3c725474',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo9.png',
        name: 'logo9.png',
        alt: '',
        width: 300,
        height: 171
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'f5655204',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo10.png',
        name: 'logo10.png',
        alt: '',
        width: 230,
        height: 298
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'db65f9a6',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo11.png',
        name: 'logo11.png',
        alt: '',
        width: 297,
        height: 260
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '5236a158',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo13.png',
        name: 'logo13.png',
        alt: '',
        width: 300,
        height: 180
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'cac62841',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo14.png',
        name: 'logo14.png',
        alt: '',
        width: 300,
        height: 140
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'b27ed343',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo15.png',
        name: 'logo15.png',
        alt: '',
        width: 299,
        height: 105
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '6d94c077',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo16.png',
        name: 'logo16.png',
        alt: '',
        width: 299,
        height: 156
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
